import React from "react";

const DayRemain = ({ className }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7792 7H33.2742C33.9172 7 34.5372 7.25284 34.9907 7.71254C35.45 8.1665 35.7083 8.78711 35.7083 9.43644V15.1196H64.2974V9.43644C64.2974 8.0918 65.3882 7 66.7315 7H71.2265C72.5699 7 73.6549 8.0918 73.6549 9.43644V15.1196H84.8552C85.9516 15.1196 87.008 15.5563 87.7887 16.332C88.5637 17.1135 89 18.1709 89 19.2684V88.6381C89 89.8448 88.5235 91.0056 87.6681 91.856C86.8128 92.7122 85.6531 93.1949 84.4476 93.1949H15.5582C13.038 93.1949 11 91.155 11 88.6381V19.2684C11 16.9756 12.86 15.1196 15.1506 15.1196H26.3451V9.43644C26.3451 8.0918 27.4359 7 28.7792 7ZM15.6845 88.5117H84.3213V41.1734H15.6845V88.5117Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DayRemain;
